/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  BatchModeTransaction,
  BatchOperationAdd,
  BatchOperationUpdate,
  ConcurrencyError,
  IRListItem,
} from '@rhybus/api'
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, useEffect, useState } from 'react'

import { mpfRListsHttp } from '../../assets/ts/api/mpf-r-lists-http'
import { transactionBatch } from '../../assets/ts/data/data'
import { LIST_NAME as DISCUSSION_LIST_NAME } from '../../assets/ts/data/discussions'
import { LIST_NAME, } from '../../assets/ts/data/inquiry/inquiry'
import {
  LIST_NAME as HISTORY_LIST_NAME,
} from '../../assets/ts/data/inquiry/inquiry-history'
import {
  encodeHTML,
  handleRoute,
  sendNotification,
  updateInvolvedUsers,
} from '../../assets/ts/general/general'
import { MetadataContext } from '../../store/metadata-context-provider'
import { UserContext } from '../../store/user-context-provider'
import {
  ACTIONS,
  COMMENT_TYPES,
  CONCURRENCY_ERR_MSG,
  DISCUSSION_LOG,
} from '../../utils/constants/global-constants'
import CustomSelect from '../../utils/controls/custom-select'
import InputTextArea from '../../utils/controls/input-text-area'
import { Priority } from '../../utils/controls/select-options-data'
import Alert from '../alert/alert'
import DialogBox from '../alert/dialog-box'
import PageOverlayBusy from '../page-overlay/page-overlay-busy'
import ActionButtons from './action-buttons'
import Buttons from './buttons'
import './buttons.css'

interface Props {
  action: string
  buttonColor: string
  currentUserRole: string
  elevateInputs
  elevateTo
  icon: string
  id?: any
  multipleItems?: any
  name: string
  popupBtnRef: any
  popupClassName: string
  popupCloseOpenFunctionality: (
    type: string,
    value: number,
    top: number,
    xPosition: number,
    left: number,
    elementHeight: number,
    offsetWidth: number
  ) => void
  setDisableCheckBox
  setElevateInputs
  setRefresh: (refresh: boolean) => void
  setShowElevateErrorMsgs
  showElevateErrorMsgs
  showHide: boolean
  singleItem: any
  style: React.CSSProperties
}

const ElevateButton = (props: Props) => {
  const {
    action,
    buttonColor,
    currentUserRole,
    elevateInputs,
    elevateTo,
    icon,
    id,
    multipleItems,
    name,
    popupBtnRef,
    popupClassName,
    popupCloseOpenFunctionality,
    setDisableCheckBox,
    setElevateInputs,
    setRefresh,
    setShowElevateErrorMsgs,
    showElevateErrorMsgs,
    showHide,
    singleItem,
    style,
  } = props
  const { me } = useContext(UserContext)
  const { inquiryStatuses, tooltipObj } = useContext(MetadataContext)

  const [displayAlert, setDisplayAlert] = useState<boolean>(false)
  const [showConfirmReload, setShowConfirmReload] = useState<boolean>(false)
  const [showPageOverlay, setShowPageOverlay] = useState<boolean>(false)

  const [alertMessage, setAlertMessage] = useState('')

  const onChangeInputSelect = (e: any) => {
    if (e.value === 'High' || e.value === 'Normal') {
      setElevateInputs({ ...elevateInputs, Priority: e.value })
    } else if (e.target?.value) {
      setElevateInputs({ ...elevateInputs, comment: e.target.value })
      setShowElevateErrorMsgs({ ...showElevateErrorMsgs, comment: { show: false } })
    } else {
      setElevateInputs({ ...elevateInputs, ElevateTo: e.value })
      setShowElevateErrorMsgs({ ...showElevateErrorMsgs, ElevateTo: { show: false } })
    }
  }
  const validateInputs = () => {
    let isValid = true
    const validityObj = showElevateErrorMsgs

    Object.keys(showElevateErrorMsgs).forEach((requiredInput) => {
      if (
        elevateInputs[requiredInput] === '' ||
        elevateInputs[requiredInput] === 'Select' ||
        elevateInputs[requiredInput] === null
      ) {
        validityObj[requiredInput].show = true
        isValid = false
      }
    })

    setShowElevateErrorMsgs({ ...validityObj })
    return isValid
  }
  const handleSubmit = async () => {
    const isValid = validateInputs()
    if (isValid) {
      setShowPageOverlay(true)
      const itemTime = new Date()
      const userRoleForDiscussion = inquiryStatuses
        .filter((status) => status.StatusCode === elevateInputs.ElevateTo)
        .map((statusCode) => statusCode.StatusDescription)[0]
        .split('-')
        .join(' ')
      const inquiryObj = {
        AssignedTo: null,
        CurrentlyServicingBy: 'MPF',
        InvolvedUsers: updateInvolvedUsers(singleItem, me.userId),
        ItemModified: itemTime,
        ItemModifiedBy: me.userId,
        PreviousStatusCode: singleItem.StatusCode,
        Priority: elevateInputs.Priority,
        StatusCode: elevateInputs.ElevateTo,
        eKey: singleItem.eKey,
        eTag: singleItem.eTag,
      }
      const historyObj = {
        ActionCode: ACTIONS.Elevated,
        InquiryGUID: singleItem.InquiryGUID,
        InquiryID: singleItem.InquiryID,
        ItemCreated: itemTime,
        ItemCreatedBy: me.userId,
        ItemModified: itemTime,
        ItemModifiedBy: me.userId,
        PreviousServicingBy: singleItem.CurrentlyServicingBy,
        PreviousStatusCode: singleItem.StatusCode,
        SectionCode: singleItem.SectionCode,
        ServicingBy: 'MPF',
        StatusCode: elevateInputs.ElevateTo,
        UserRole: currentUserRole,
      }
      const discussionObj = {
        Comment: encodeHTML(elevateInputs.comment.trim()),
        CommentType: COMMENT_TYPES.Internal,
        InquiryGUID: singleItem.InquiryGUID,
        InquiryID: singleItem.InquiryID,
        IsActionComment: true,
        ItemCreated: itemTime,
        ItemCreatedBy: me.userId,
        ItemModified: itemTime,
        ItemModifiedBy: me.userId,
        Subject: `${DISCUSSION_LOG.Elevate} ${userRoleForDiscussion}`,
        UserRole: currentUserRole,
      }
      try {
        const batchResult: any = await transactionBatch([
          { data: inquiryObj, list: LIST_NAME, op: BatchOperationUpdate },
          {
            data: historyObj,
            list: HISTORY_LIST_NAME,
            op: BatchOperationAdd,
          },
          {
            data: discussionObj,
            list: DISCUSSION_LIST_NAME,
            op: BatchOperationAdd,
          },
        ])
        if (batchResult.result === 'PASS') {
          await sendNotification(
            historyObj.ActionCode,
            { ...singleItem, ElevatedUserRole: elevateInputs.ElevateTo },
            me,
            currentUserRole.replace('[SECTION_NAME]', singleItem['Section/MetadataValue']),
            false
          )
          setRefresh(true)
        }
      } catch (error) {
        if (error instanceof ConcurrencyError) {
          setShowConfirmReload(true)
        } else {
          console.error(error)
        }
      }
    }
    setShowPageOverlay(false)
  }
  const handleMultipleSubmit = async () => {
    const isValid = validateInputs()
    if (multipleItems.length === 0) {
      setAlertMessage(`Please select inquiry.`)
      setDisplayAlert(true)
    }
    function userRoleAndCurrentlyServicingByCheck(currentUserRole, multipleItems) {
      const servicingByValues = multipleItems.map((item) => item.CurrentlyServicingBy)
      const currentlyServicingBySame = new Set(servicingByValues).size === 1
      if (multipleItems.length === 0) {
        return false
      }
      if (!currentlyServicingBySame) {
        setAlertMessage("You don't have permission to perform this action on the selected item(s).")
        setDisplayAlert(true)
        return false
      }

      if (currentUserRole === 'MPF Leadership' && servicingByValues.includes('CSS')) {
        setAlertMessage("You don't have permission to perform this action on the selected item(s).")
        setDisplayAlert(true)
        return false
      } else if (currentUserRole === 'CSS' && servicingByValues.includes('MPF')) {
        setAlertMessage("You don't have permission to perform this action on the selected item(s).")
        setDisplayAlert(true)
        return false
      }

      return true
    }

    userRoleAndCurrentlyServicingByCheck(currentUserRole, multipleItems)
    if (isValid && userRoleAndCurrentlyServicingByCheck(currentUserRole, multipleItems)) {
      setShowPageOverlay(true)
      try {
        const successful = await sendBatchToServer(2, multipleItems, performInquiryBatch)
        if (successful !== undefined) {
          await sendBatchToServer(1, multipleItems, performDiscussionBatch)
          await sendBatchToServer(1, multipleItems, performHistoryBatch)
          setDisableCheckBox(false)
          location.reload()
        }
      } catch (error) {
        if (error instanceof ConcurrencyError) {
          setShowConfirmReload(true)
        } else {
          console.error(error)
        }
      }
    }
    setShowPageOverlay(false)
  }
  async function sendToServer(batchItems) {
    // Simulate async server request
    return await mpfRListsHttp().createBatch(2, batchItems).execute()
  }
  async function sendBatchToServer(batchType, batchItems, performBatchFunction) {
    try {
      const result = await performBatchFunction(batchType, batchItems)
      return result !== undefined ? result : true
    } catch (error) {
      console.error('Multiple Elevate', error)
    }
  }
  const performInquiryBatch = async (batchOperation, multipleItems) => {
    const createInquiryObjArray = (
      itemModified,
      itemModifiedBy,
      previousStatusCode,
      priority,
      statusCode,
      eKey,
      eTag
    ) => ({
      AssignedTo: null,
      CurrentlyServicingBy: 'MPF',
      ItemModified: itemModified,
      ItemModifiedBy: itemModifiedBy,
      PreviousStatusCode: previousStatusCode,
      Priority: priority,
      StatusCode: statusCode,
      eKey: eKey,
      eTag: eTag,
    })
    const batchInquiryItems: any = []

    const jsonResults = multipleItems || []
    const itemTime = new Date()
    jsonResults.forEach((result) => {
      const { StatusCode, eKey, eTag } = result
      const inquiryArray = createInquiryObjArray(
        itemTime,
        me.userId,
        StatusCode,
        elevateInputs.Priority,
        elevateInputs.ElevateTo,
        eKey,
        eTag
      )
      batchInquiryItems.push({
        data: inquiryArray,
        list: LIST_NAME,
        op: batchOperation,
      })
    })

    await sendToServer(batchInquiryItems)
  }
  const performDiscussionBatch = async (batchOperation, multipleItems) => {
    const createDiscussionObjArray = (
      comment,
      commentType,
      inquiryGUID,
      inquiryID,
      itemCreatedBy,
      itemCreated,
      itemModifiedBy,
      itemModified,
      subject,
      userRole
    ) => ({
      Comment: comment,
      CommentType: commentType,
      InquiryGUID: inquiryGUID,
      InquiryID: inquiryID,
      IsActionComment: true,
      ItemCreated: itemCreated,
      ItemCreatedBy: itemCreatedBy,
      ItemModified: itemModified,
      ItemModifiedBy: itemModifiedBy,
      Subject: subject,
      UserRole: userRole,
    })
    const batchInquiryDiscussionsItems: any = []

    const jsonResults = multipleItems || []
    const itemTime = new Date()
    const userRoleForDiscussion = inquiryStatuses
      .filter((status) => status.StatusCode === elevateInputs.ElevateTo)
      .map((statusCode) => statusCode.StatusDescription)[0]
      .split('-')
      .join(' ')
    jsonResults.forEach(async (result) => {
      const { InquiryGUID, InquiryID, eKey, eTag } = result

      const inquiryDiscussionsArray = createDiscussionObjArray(
        encodeHTML(elevateInputs.comment.trim()),
        COMMENT_TYPES.Internal,
        InquiryGUID,
        InquiryID,
        me.userId,
        itemTime,
        me.userId,
        itemTime,
        `${DISCUSSION_LOG.Elevate} ${userRoleForDiscussion}`,
        currentUserRole
      )
      batchInquiryDiscussionsItems.push({
        data: inquiryDiscussionsArray,
        list: DISCUSSION_LIST_NAME,
        op: batchOperation,
      })
    })
    return await sendToServer(batchInquiryDiscussionsItems)
  }
  const performHistoryBatch = async (batchOperation, multipleItems) => {
    const createHistoryObjArray = (
      actionCode,
      inquiryGUID,
      inquiryID,
      itemCreated,
      itemCreatedBy,
      itemModified,
      itemModifiedBy,
      previousServicingBy,
      previousStatusCode,
      sectionCode,
      statusCode,
      userRole
    ) => ({
      ActionCode: actionCode,
      InquiryGUID: inquiryGUID,
      InquiryID: inquiryID,
      ItemCreated: itemCreated,
      ItemCreatedBy: itemCreatedBy,
      ItemModified: itemModified,
      ItemModifiedBy: itemModifiedBy,
      PreviousServicingBy: previousServicingBy,
      PreviousStatusCode: previousStatusCode,
      SectionCode: sectionCode,
      ServicingBy: 'MPF',
      StatusCode: statusCode,
      UserRole: userRole,
    })
    const batchInquiryHistoryItems: any = []

    const jsonResults = multipleItems || []
    jsonResults.forEach(async (result) => {
      const { CurrentlyServicingBy, InquiryGUID, InquiryID, SectionCode, StatusCode, eKey, eTag } =
        result
      const itemTime = new Date()
      const inquiryHistoryArray = createHistoryObjArray(
        ACTIONS.Elevated,
        InquiryGUID,
        InquiryID,
        itemTime,
        me.userId,
        itemTime,
        me.userId,
        CurrentlyServicingBy,
        StatusCode,
        SectionCode,
        elevateInputs.ElevateTo,
        currentUserRole
      )

      batchInquiryHistoryItems.push({
        data: inquiryHistoryArray,
        list: HISTORY_LIST_NAME,
        op: batchOperation,
      })
    })

    await sendToServer(batchInquiryHistoryItems)
  }

  return (
    <div>
      {displayAlert && (
        <Alert
          alerttextclass='poppins-semibold font-13 text-center'
          btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
          btn1iconclassNmae='icon-checked font-12 pe-1'
          btn2classNmae='btn btn btn-border1 darktext btn-sm poppins-semibold font-12 border-radius text-uppercase'
          btn2iconclassNmae='icon-close color-primary font-12 pe-1'
          cancel='Cancel'
          className='alert-info'
          message={alertMessage}
          onClick={() => {
            setAlertMessage('')
            setDisplayAlert(false)
          }}
          yes='OK'
        />
      )}
      <ActionButtons
        aria-label={name}
        className={`btn-lg font-12 ${buttonColor} whitetext text-nowrap border-radius poppins-bold text-uppercase`}
        icon={icon}
        id={id}
        isClick={action}
        label={name}
        name={name}
        popupCloseOpenFunctionality={popupCloseOpenFunctionality}
        showHide={showHide}
        type='button'
      />

      {showHide ? (
        <div
          className={`popup popup-md ${popupClassName}`}
          ref={popupBtnRef}
          style={style}
        >
          <div className='row'>
            <div className='col-dm-12 mt-0 mb-1'>
              <CustomSelect
                className='form-sm w-100 sourcesanspro font-13 customselect'
                error={showElevateErrorMsgs.ElevateTo.show}
                formClassName='form-vertical text-nowrap mb-2'
                id='ElevateTo'
                info={tooltipObj?.elevateTo?.TooltipDescription}
                infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                }}
                isInfo
                isMandatory
                label='Elevate To'
                name='Elevate To'
                onChange={onChangeInputSelect}
                options={elevateTo}
                value={elevateInputs.ElevateTo}
              />
            </div>
            <div className='col-dm-12 mt-0 mb-2'>
              <CustomSelect
                className='form-sm w-100 sourcesanspro font-13 customselect'
                formClassName='form-vertical text-wrap mb-2'
                id='Priority'
                info={tooltipObj?.elevatePriority?.TooltipDescription}
                infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'mb-1 font-12 poppins-medium title-color',
                }}
                isInfo
                label='Priority'
                name='Priority'
                onChange={onChangeInputSelect}
                options={Priority}
                value={elevateInputs.Priority}
              />
            </div>
            <div className='col-md-12 mt-0'>
              <InputTextArea
                className='form-lg font-13 sourcesanspro  min-h-100 p-1'
                cols='30'
                error={showElevateErrorMsgs.comment.show}
                formClassName=' form-vertical'
                info={tooltipObj?.elevateComment?.TooltipDescription}
                infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
                infoIcon='icon-info color-primary'
                inputProps={{
                  className: 'font-12 poppins-medium title-color2 mb-1',
                  id: 'Comment',
                  name: 'Comment',
                  placeholder: 'Enter your Comment',
                }}
                isInfo
                isMandatory
                label='Comment'
                  onChange={onChangeInputSelect}
                rows='3'
                type='textarea'
              />
            </div>
          </div>

          <div className='pt-2 d-flex gap-2'>
            {multipleItems && !singleItem && (
              <Buttons
                aria-label='Ok'
                className='btn btn-sm btn-primary whitetext font-11 border-radius ms-auto text-uppercase poppins-semibold'
                icon='icon-checked font-10 me-1'
                label='Ok'
                onClick={handleMultipleSubmit}
              />
            )}
            {singleItem && (
              <Buttons
                aria-label='Ok'
                className='btn btn-sm btn-primary whitetext font-11 border-radius ms-auto text-uppercase poppins-semibold'
                icon='icon-checked font-10 me-1'
                label='Ok'
                onClick={handleSubmit}
              />
            )}

            <ActionButtons
              className='btn-border1 title-color3 btn-sm font-11 border-radius text-uppercase poppins-semibold'
              icon='icon-close font-9 me-1 color-primary'
              isClick='Cancel'
              label='Cancel'
              name='Cancel'
              onClick={() => {
                setDisableCheckBox? setDisableCheckBox(false) : ''
              }}
              popupCloseOpenFunctionality={popupCloseOpenFunctionality}
              showHide={showHide}
              type='button'
            />
          </div>
        </div>
      ) : null}
      {showPageOverlay && <PageOverlayBusy />}
      {showConfirmReload && (
        <DialogBox
          handleRouteNo={() => handleRoute('cancel', setShowConfirmReload)}
          handleRouteYes={handleRoute}
          message={CONCURRENCY_ERR_MSG}
          primaryText={'Ok'}
          secondaryText={'Cancel'}
        />
      )}
    </div>
  )
}

export default ElevateButton
